const en = {
  language: {
    zh: '简体中文',
    en: 'English'
  },
  userDetails: 'User details',
  lastName: 'Last name',
  firstName: 'First name',
  email: 'Email',
  yourEmailBeenVerified: 'Your email hasn&apos;t been verified.',
  verifyEmail: 'Verify email',
  paymentMethods: 'Payment methods',
  search: 'Search',
  clear: 'Clear',
  agreement: 'Search for Package Rates',
  allOrders: 'All',
  upcoming: 'Upcoming',
  completed: 'Completed',
  cancelled: 'Cancelled',
  yearN: 'year',
  month: 'month',
  day: 'day',
  bedBreakfast: 'Free breakfast',
  nonFefundable: 'Non-refundable',
  creationDate: 'Creation date:',
  confirmed: 'Confirmed',
  bookingReference: 'Booking reference',
  viewDetails: 'View details',
  pending: 'Pending',
  unpaid: 'Unpaid',
  back: 'Back',
  yourBookingHasBeenCancelled: 'Your booking was cancelled.',
  bookingDetails: 'Booking details',
  roomName: 'Room',
  checkInTime: 'Check-in',
  checkOutTime: 'Check-out',
  travelDates: 'Night',
  roomNumber: 'Room',
  guest: 'Guest',
  guestName: 'Guest name',
  room: 'room',
  bedType: 'Bed type',
  breakfast: 'Breakfast',
  cancellationPolicy: 'Cancellation policy',
  specialRequests: 'Special requests',
  cancellationDateTime: 'Cancellation date',
  priceDetails: 'Price details',
  onOurSite: 'room',
  avgNight: 'avg. price per night',
  taxesFees: 'Taxes & fees',
  totalPrice: 'Total price',
  paymentDetails: 'Payment and refund details',
  paymentMethod: 'Payment method',
  creditCardNumber: 'Credit card number',
  paymentAmounts: 'Payment amounts',
  cancellationCharges: 'Cancellation charges',
  refund: 'Refund',
  bookingConfirmationHasBeenSend: 'We have received your booking request and are currently in urgent contact with the hotel to process it. We will notify you via email as soon as we have an update. Thank you once again for choosing Roompai.',
  printVoucher: 'Download voucher',
  contactGus: 'Contact us',
  cancel: 'Cancel booking',
  goingTo: 'Destination/Property name',
  startIn: 'Check-in',
  endOut: 'Check-out',
  betweenRoom: 'room',
  childrenAges: 'Children&apos;s ages (years)',
  myFavorite: 'List of favorites',
  seeAllPhotos: 'See all photos',
  swimmingPool: 'Swimming pool',
  freeWifi: 'Free WiFi',
  freeShuttleBus: 'Free shuttle bus',
  airConditioning: 'Air conditioning',
  resaurants: 'Resaurants',
  seeallFacilities: 'See all facilities',
  whatNearby: 'What&apos;s nearby',
  minDrive: 'min drive',
  minWalk: '',
  seeMoreDetails: 'See more details',
  facilities: 'Facilities',
  overview: 'Overview',
  policies: 'Policies',
  freeBreakfast: 'Free breakfast',
  freeCancellation: 'Free cancellation',
  roomType: 'Room type',
  price: 'Price',
  perRoomNight: 'per night',
  instantConfirmation: 'Instant confirmation',
  afterTax: 'Per night after tax',
  book: 'Book now',
  onlyLast: 'Only',
  showMore: 'Show more',
  opened: 'Opening',
  telephone: 'Telephone',
  hotelAddress: 'Hotel position',
  roomFeatures: 'Room features',
  bookingNotice: 'Booking notice',
  improtantInformation: 'Important information',
  cityNotice: 'City Notice',
  childrenNotice: 'Children',
  pets: 'Pets',
  ageRequirements: 'Age requirements',
  checkInFrom: 'Check-in from',
  checkOutUntil: 'Check-out until',
  extraService: 'Extra service',
  breakfastMoney: 'Breakfast fee',
  unlessRoomPrice: '(unless included in room price)',
  restaurantsNumber: 'Number of restaurants',
  breakfastType: 'Breakfast type',
  openingHours: 'Opening hours',
  chargeOrDepositAboveWillBePaidHotel: 'The charge or deposit above will be paid at hotel.',
  amountAboveIsOnlyForYouReferenceFinalChargeByHotel: 'The amount above is only for your reference. The final charge will depend on the actual amount chaged by hotel.',
  languageSpoken: 'Languages spoken',
  internetAccess: 'Internet access',
  waysToRelax: 'Things to do, ways to relax',
  dinDrinkSnack: 'Dining, drinking, and snacking',
  transportService: 'Transport service',
  forTheKids: 'For the kids',
  other: 'Others',
  avaliableInAllRoom: 'Available in all rooms',
  searchByProperty: 'Search by property name',
  propertyClass: 'Property class',
  pricePerNight: 'Price per night',
  filter: 'Filter',
  bestMatch: 'Best match',
  lowPriceFirst: 'Low price first',
  highPropertyClass: 'High property class',
  leftAtThisPrice: '',
  selectRoom: 'Select room',
  properties: 'properties',
  propertyClass5: 'Property class 5',
  propertyClass4: 'Property class 4',
  propertyClass3: 'Property class 3',
  propertyClass2: 'Property class 2',
  lessThan: 'Less than',
  greaterThan: 'Greater than',
  forgotPassword: 'Forgot password',
  electronEmail: 'Email',
  pleaseYourEmailInBox: 'Please enter your email in the box above.',
  weSendYouLinkToAccessInstructions: 'We will send you a link to access further instructions.',
  resetPassword: 'Reset password',
  backToSignIn: 'Back to sign in',
  signIn: 'Sign in',
  linkToResetYoutPasswordSend: 'The link to reset your password has been sent to  ',
  pleaseCheckYoutEmail: 'Please check your mail.',
  emailOrPasswordIncorrect: 'Email or Password is incorrect.',
  pleaseCheckThem: 'Please check them.',
  password: 'Password',
  createAccount: 'Create account',
  retypePassword: 'Retype password',
  alreadyHaveAnAccount: 'Already have an account',
  bookingIsNowComplete: 'Your booking is now completed!',
  minutesTenYouBookingSendEmail: 'In the next 10 minutes an email containing your booking details and voucher will be sent to',
  backHome: 'Back to homepage',
  manageMyBookings: 'Manage my bookings',
  justMiss: 'Just miss it',
  justsoldOut: 'It&apos;s just sold out.',
  likeToCheckOtherPlans: 'Would you like to check other plans?',
  bookCurAotherRoom: 'Book another room',
  pendingMeanBookingnotCompleteYouBookingHotel: 'Pending means the booking has not been completed yet. You&apos;ve booked a popular hotel,',
  limitedInventoriesAndBestPrice: 'which has limited inventories and best price.',
  hotelAndYouWillReceiveFinalBookingStatusInbox: 'So we will double check the inventory with the hotel and keep you informed of the updated booking status within 10 minutes.',
  bookingIsPendingWekeepYouInformedMinutes: 'Your booking is pending. We will keep you informed of the updated booking status within 10 minutes.',
  bookingStatusWilBeSendToYourEmail: 'Booking status will be sent to your email',
  youBookingIsConfirming: 'Your booking is being confirmed...',
  pleaseDoNotCLoseYourBrowserClickBackButton: 'Please do not close your browser or click the back button….',
  hoteInformation: 'Hotel details',
  customerInformation: 'Guest details',
  finalStep: 'Final step',
  minute: 'minute',
  bookingInformation: 'Booking information',
  taxesAndServiceFees1: 'Taxes and service fees are generally recovery charges which Roompai pays to the vendor or which are collected by the vendor. For more details, please see the Roompai Terms of Use. Tax and service fees may also contain fees that Roompai retains as compensa.',
  createAccounts: 'Create account',
  signingYourAccountBooking: 'allows for faster bookings and easier management of them.',
  please: 'Please fill up all information within',
  second: 'second',
  fillUpAllPriceDiff: 'to avoid any price differences.',
  customerInformationDesc: 'Customer information',
  pleaseEnglishLetter: 'Please enter text in English only.',
  emailAddr: 'Email',
  retypeEmail: 'Retype email',
  pleaseEmailFieldsMatch: 'Please make sure the “Email” and “Retype email” fields match.',
  phoneNumber: 'Phone number',
  pleaseValidPhone: 'Please enter a valid phone number.',
  nationality: 'Nationality',
  pleaseLastName: 'Please enter last name.',
  pleaseTextEnglish: 'Please enter text in English only.',
  pleaseFirstName: 'Please enter first name.',
  haveSpecialRequests: 'Do you have any special requests?',
  specialRequestsAreGuaranteed: 'Special requests are not guaranteed. But we will try our best to make yourselves satisfied. You can always send us special reqeusts by email or by phone after booking.',
  placeEnterTexteEnglish: 'Please enter text in English only.',
  buttonMeansYouAgree: 'Click the button below and it means you agree to Roompai&apos;s',
  termsUse: 'Terms of use',
  and: 'and',
  privacyPolicyO: 'Privacy policy',
  riskFree: 'Risk free! No cancellation fee before',
  propertyLocalTime: 'Monday',
  noCancelFeeBefore: ' ',
  goFinalStep: 'NEXT: FINAL STEP',
  pleaseEnterYourEmailOrYouMightMissBooking: 'Please enter your email, or you might miss the booking confirmation.',
  pleaseValidEmail: 'Please enter a valid email.',
  reservationConfirmationEmail: 'Make sure you receive the reservation confirmation email',
  priceInventoryDifferences: 'Please pay for it within 4 minutes to avoid any price or inventory differences.',
  encryptedSecure: 'All card information is fully encrypted, secure and protected.',
  mySavedCards: 'My saved cards',
  cardHolderName: 'Card holder name',
  debitCardNumber: 'debit card number',
  expiryDate: 'Expiry date',
  cvv: 'CVC/CVV',
  validCVV: 'Please enter a valid CVC/CVV.',
  digitSecurityCode: 'digit security code',
  creditCard: 'Credit card',
  bookNow: 'BOOK NOW',
  appearsOnTheCard: 'Please enter the cardholder&apos;s name exactly as it appears on the card.',
  validCardNumber: 'Please enter a valid card number.',
  pleaseValidCardExpiry: 'Please enter a valid card expiry date.',
  justMissO: 'Just miss it!',
  noInventory: 'Sorry, we have no inventory of this room at this property on your dates.',
  bookAotherRoom: 'Book another room',
  noRooms: 'Sorry, we have no rooms at this property on your dates.',
  onlyStepLeft: 'Only 1 step left!',
  roomOnly: 'Only',
  roomLeft: 'room left!',
  continueBooking: 'Continue booking',
  confirmingPriceIng: 'Confirming price',
  confirmingPrice: 'Confirming price',
  stillInterested: 'Still interested?',
  choiceTopSelling: 'This choice is a top selling plan!',
  offerSoldOut: 'The best offer has been sold out!',
  updatePlan: 'An update plan with  ',
  higherPriceOfSameRoom: 'higher price of same room type',
  propertyIsRecommended: 'at same property is recommended.',
  wouldBookingIt: 'Would you like to continue booking it?',
  myBookings: 'My bookings',
  myAccount: 'My account',
  customerServiceEmail: 'Customer service email',
  customerServicePhone: 'Customer service phone number',
  internationalCall: 'For domestic call',
  domesticCall: 'For international call',
  faq: 'FAQs',
  privacyPolicy: 'Privacy policy',
  termsOfUse: 'Terms of use',
  aboutUs: 'About us',
  contactUs: 'Contact us',
  signOut: 'Sign out',
  anyDestination: 'City, hotel accommodation, scenic spots or any destination',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  determine: 'OK',
  bookingReferences: 'Booking reference',
  sendEmail: 'Send Email',
  bookingInfo: 'Booking details',
  cancellation: 'Cancellation',
  modification: 'Modification',
  onlyBed: 'Only Bed',
  refundable: 'Refundable',
  cancellationDate: 'Cancellation date:',
  adult: 'adult',
  adults: 'adults',
  child: 'child',
  children: 'children',
  year: 'year old',
  years: 'years old',
  breakfast2: 'breakfast for 2',
  dateFreeCancellation: 'Free cancellation before',
  filterBy: 'Filter by',
  limitedAvailability: 'Limited availability',
  bookingFailed: 'Your booking failed.',
  pleaseSelect: 'Please select',
  setUp: 'set up',
  languageAll: 'Language',
  currency: 'Currency',
  youCanLoginAlterPrice: 'You can find a lower special price after logging in!',
  allLanguages: 'All languages',
  allCurrency: 'All currency',
  name: 'Name',
  deletePay: 'Remove saved card',
  night: 'night',
  between: 'room',
  home: 'Home',
  bookmin: 'book',
  searchCriteria: 'Search criteria',
  filters: 'filters',
  deleteFilter: 'Remove',
  pleaseModifyYourSearchAndTryAgain: 'We couldn&apos;t find any results that match your search criteria. Please modify your search and try again.',
  sorryHaveNoRoomsAtPropertyOn: 'Sorry, we have no rooms at this property on your dates.',
  changeYouDates: 'Change your dates',
  haveNoBooking: 'You have no bookings~',
  haveNoUpcomingBooking: 'You have no upcoming bookings~',
  haveNoCompletedCancelBooking: 'You have no completed bookings~',
  haveNoCancelBooking: 'You have no cancelled bookings~',
  noFavoriteHotelAddFavorite: 'No favorite hotel? Go to add one in your favorite list~',
  kilometre: 'km',
  rightAtThisPrice: 'left at this price',
  hotelDetailroomCount: 'left on our site',
  floor: 'Floor',
  window: 'Window',
  scenery: 'Scenery',
  area: 'Area',
  maximum: 'Maximum',
  soldLeft: 'Just miss it! Try',
  soldChangeDate: 'changing travel date',
  soldOr: 'or',
  soldOtherHotel: 'checking similar properties',
  soldRight: '~',
  VerifyEmailSuccess: 'Your email was verified successfully!',
  sendEmailLeft: 'We will send verification email to',
  sendEmailRight: '.Please check it in your inbox and finish the verification.',
  checkinCheckout: 'Check in / check out',
  practicalInformation: 'Practical information',
  userEmailVerifyFail: 'Email verification is failed! Please go to inbox and try again.',
  yourBookingHasBeenConfirm: 'Your booking is confirmed.',
  orderNoConfirmLeft: 'Your booking is pending. The booking status will be updated within',
  orderNoConfirmRight: ' ',
  orderPaymentLeft: 'Your booking is still unpaid.Please pay for it within',
  orderPaymentRight: 'to avoid any price differences.',
  noBedBreakfast: 'Only Bed',
  searchOtherHotelRoom: 'See available properties',
  windowed: 'with window',
  windowless: 'no window',
  good: 'Good',
  awesome: 'Awesome',
  excellent: 'Excellent',
  exceptional: 'Exceptional',
  veryClean: 'Very clean',
  excellentService: 'Excellent service',
  fantasticFood: 'Fantastic food',
  greatLocation: 'Great location',
  comfortable: 'Comfortable',
  warmStaff: 'Warm staff',
  niceSwimmingPool: 'Nice swimming pool',
  niceKidsFacilities: 'Nice kids facilities',
  awesomeRestaurant: 'Awesome restaurant',
  fantasticGym: 'fantastic gym',
  niceRoom: 'Nice room',
  niceBar: 'Nice bar',
  orderCancel: 'Cancel booking',
  orderCancelReason: 'Reason for cancellation:',
  selectCancelReason: 'Select an option',
  nowCancelRefund: 'If you cancel it now, you will be charged',
  orderPrice: 'Total amount',
  cancelPrice: 'Cancellation fee',
  refundPrice: 'Refund',
  close: 'Close',
  continueCancel: 'Cancel',
  canNotCancelLeft: 'Because this booking is non refundable now. You will be charged',
  canNotCancelRight: '(total amount of booking) if you continue to cancel it.',
  isContinueCancel: 'Do you still want to cancel it?',
  goToPay: 'Pay now',
  yourCardOrAccountShouldReceiveRefundAmountLeft: 'We will initiate',
  yourCardOrAccountShouldReceiveRefundAmountRight: 'to your initial payment method. Your card or account should receive the refund amount within 10 working days. If you have any additional questions about your refund, please contact your bank/credit card issuer directly.',
  orderCancelSuccess: 'Your booking was cancelled successfully.',
  yourCardOrAccountShouldReceiveRefundAmountRightTwo: 'to your initial payment method. If the order used a coupon, the coupon will be refunded to your account and can be used for your next booking.',
  contactBank: 'Please contact your bank/credit card issuer directly.',
  freeCancellationBefore: 'Free cancellation before',
  taxesAndServiceFees: 'Taxes and service fees are generally recovery charges which Roompai pays to the vendor or which are collected by the vendor. For more details, please see the Roompai Terms of Use. Tax and service fees may also contain fees that Roompai retains as compensation for processing the reservation.',
  pleaseValidEmailReservationConfirmationEmail: 'Please enter a valid email. Make sure you receive the reservation confirmation email.',
  creditDebitCard: 'Credit/debit card',
  creditBeditCardNumber: 'Credit/debit card number',
  cancelForWaitPay: 'Your booking failed due to payment timeout. If you still need it, please book again.',
  cancelForWaitConfirm: 'Your booking failed because the plan has been sold out. Try to change your date or check other properties.',
  orderWaitPaymentMess: 'Your booking is still unpaid.Please pay for it soon to avoid any price differences.',
  youBeenThisPageForeTooLongTime: 'You&apos;ve been this page for too long time. Please back to homepage to rebook.',
  collectionPrefrences: 'Data collection preferences',
  byClickAcceptAllowRoompaiMedia: 'By clicking “Accept” you allow Roompai.com and our trusted partners to use your personal information for analytical and marketing purposes. Analytical processing gives us an insight into how our website is used, so we can improve our site and services. Marketing processing helps us decide which products to show you on and off our website, measure our visitors and allow you to share things on social media.',
  accept: 'Accept',
  decline: 'Decline',
  verifyEmailSendEmail: 'The link to verify email has been sent to',
  payDetail: 'Payment details',
  amounts: 'Payment amounts',
  orderCancelfaild: 'Your cancellation failed!',
  contactCustomer: 'If you still want to cancel it, please contact our customer service team.',
  contactEmail: 'Email:',
  phoneNumberTwo: 'Phone number:',
  noPrice: '',
  youSureToDeleteTheCreditCard: 'Will you continue to delete the information of this card?',
  accountBalanceSufficient: 'You have enough credit for this booking.',
  rooms: 'rooms',
  childAge: 'Child&apos;s age (years)',
  enterNameOfDestinationOrProperty: 'Please enter the name of a destination or property to proceed.',
  onOurSites: 'rooms',
  persons: '',
  logined: 'Logined',
  noThisUser: 'Not your account?',
  productType: 'Product type',
  score: '',
  mailboxExists: 'This E-mail account already exists.',
  companyName: 'Eseeker Information Technology Co., Ltd.',
  companyAddr: 'F1-F2, Building 8, Block 3, Tiantongyuan, Dongxiaokou Zhen, Changping District, Beijing, China',
  customerService: 'Customer service contact',
  willRefundTime: 'Your card or account should receive the refund amount within 10 working days.',
  nopic: 'No picture',
  noCancelMsg: 'Since this booking is non refundable now, there will be no refund of it.If the order used a coupon, the coupon will be refunded to your account and can be used for your next booking.',
  norefundContactUs: 'If you have any questions about it, please contact our customer service team.',
  emailMsgLeft: 'Your voucher will be sent to',
  emailMsgRight: 'within 3 minutes.',
  networkErrorReschedule: 'Network error, please try again.',
  noOrderFound: 'No booking is found.',
  paymentFailed: 'Payment failed, please try again.',
  networkInterruptRetry: 'Network error, please try again.',
  questionsPleaseContactUs: 'If you have any questions, please contact us.',
  ToBePaidStatusWaitPatiently: 'The booking is unpaid. You can check the updated payment status of this booking within 10 minutes. Sorry to bring you inconvenience.',
  guests: 'guest',
  sortby: 'Sort by',
  hoteListSold: 'Just miss it!',
  hello: 'Hi!',
  mobileRiskFreeOne: 'Risk free!',
  mobileRiskFreeTwo: 'No cancellation fee before',
  calendar: 'Calendar',
  childNum: 'Child',
  peopleNum: 'Occupancy',
  rememberCard: 'Save this card for future use',
  floorNum: 'floor',
  bookingReferenceNo: 'Booking reference:',
  hotelRelated: 'Hotel related',
  ok: 'OK',
  childNums: 'Children',
  lookRoom: 'See available rooms',
  nights: 'Nights',
  accommodates: 'Sleeps',
  people: '',
  hotelLocation: 'Hotel location',
  weHereToHelpYou: 'We are here to help you!',
  pleaseCheckAndSeeFindYourAnswers: 'Please check and see if you could find your answers here~',
  floorTh: 'th floor',
  chineseYuan: 'Chinese Yuan',
  usDollar: 'US Dollar',
  sendVoucher: 'Send voucher',
  accountBalance: 'Account credit',
  payAccount: 'Account',
  cancelReason: 'Cancellation reasons',
  confirm: 'OK',
  hotelPackagePrice: 'I understand and accept that package rates can only be booked in combination with a flight, car, train or cruise booking for the same traveller and trip.',
  bedTypeLikeMsg: '(Bedding requests cannot be guaranteed. )',
  noRefundMsg: 'If you change or cancel your booking, you will not get a refund.',
  refundNoShowMsg: 'If you fail to arrive or cancel the booking after the check-in date, no refund will be given.',
  refundMsg: 'If the booking includes several nights and you fail to arrive on the check-in date, then if you still want to check in after that, you should contact the hotel in advance, or this booking will be cancelled.',
  refundLocalTimeMsg: 'Times are based on the property’s local time.',
  putAway: 'Show less',
  noRefundTimeMsg: 'You will not get a refund if you cancel after',
  noRefundNightMsg: 'You&apos;ll be charged for the first night of your stay plus taxes and fees if you cancel before',
  noRefundAmountOneMsg: 'You&apos;ll be charged for',
  noRefundAmountTwoMsg: 'if you cancel before',
  noRefundPercentOneMsg: 'You&apos;ll be charged for',
  noRefundPercentTwoMsg: 'of your total if you cancel before',
  beddingRequestsCannotBeGuaranteed: 'Bedding requests cannot be guaranteed.',
  rebateFefundable: 'Partial refundable before',
  bedTypePreference: 'Bedding request',
  refundOtherMsg: 'For other check in dates:',
  noRefundDateOneMsg: 'Once the booking is confirmed, you will not get a refund of the check in date from',
  noRefundDateTwoMsg: '',
  custometSourceMarket: 'Customer source market',
  allMarket: 'All markets',
  epsTermsAndCond: 'Supplier Terms & Conditions',
  agentTermsOfUse: 'Downstream Agent Agreement',
  youNeedToKnow: 'You need to know',
  fees: 'Fees',
  optionalExtras: 'Optional extras',
  specialCheckinInstructions: 'Special check-in instructions',
  checkMinAge: 'Check in min age limitation',
  transportationInformation: 'Transportation information',
  flightNumber: 'Flight number',
  date: 'Date',
  departure: 'Departure',
  arrival: 'Arrival',
  reservationCode: 'Reservation code',
  epsPkgIconfirmCusInfo: 'I confirm that the above passengers have booked their transportation (flight, cruise ship, car rental or long-distance train). In the process of communication with passengers, room reservation will always be quoted packaged with transportation reservation, and passengers will not know the unit price of room reservation. The transportation information booked by passengers is as follows:',
  planeTicket: 'Flight ticket',
  validReservationCode: 'Please enter valid reservation code',
  validflightNumber: 'Please enter valid flight number',
  validDeparture: 'Please enter valid departure IATA code',
  validArrival: 'Please enter valid arrival IATA code',
  otaMsg: 'All prices are forbidden to be sold to OTAs or meta-search websites.',
  ticketInformation: 'Flight information',
  resortFee: 'Resort fee',
  pointStr: 'Point',
  pendingPoints: 'Pending Points',
  quarter: 'Quarter',
  quantity: 'Order Quantity',
  sales: 'Sales ($)',
  loyalty: 'Loyalty Level',
  currentPoints: 'Current Points',
  progressBar: 'Progress Bar',
  pointsDiscount: 'Points Discount',
  pointsRemark: 'Calculated based on the ratio of 100 points equaling 1 US dollar.',
  pointsInformation: 'Points Information',
  event: 'Event',
  pointsStr: 'Points',
  dateTime: 'Date & Time',
  pointsTxt: 'Note: Points changes from reservations or cancellations only affect pending points balance',
  loyaltyPoints: 'Loyalty Points Summary',
  keepMyBooking: 'Keep My Booking',
  confirmCancellation: 'Confirm Cancellation',
  pointsRules: 'View Detailed Points Rules',
  pointsDetails: 'Points Details',
  payNow: 'Pay now',
  payableAtProperty: 'Payable at property',
  priceDetailMsg: 'The taxes and fees are calculated at the current exchange rate and must be paid in the local currency when paying for the accommodation.',
  salesTax: 'Sales Tax',
  packageRate: 'Package rate',
  propertyFee: 'Property fee',
  surcharges: 'Surcharges',
  mandatoryFee: 'Mandatory fee',
  mandatoryTax: 'Mandatory tax',
  taxTips: 'Taxes and fees include the estimated amount of tax paid by the travel service provider (i.e. hotel, car rental company) and/or us to the tax authority in your reservation (including but not limited to sales, occupancy and VAT). This amount may also include any of the following amounts: resort fees, cleaning fees and other fees paid by us, and/or fees charged by us, the hotel provider and/or your booking website as part of the service commission (which varies depending on location, amount and payment method). For details, please check the terms and conditions.',
  orderNoConfirm: 'Your booking is pending.',
  electronicPayment: 'Digital payment',
  wechat: 'WeChat',
  alipay: 'Alipay',
  paypal: 'PayPal',
  theTotalAmountYouChanged: 'The total amount you will be charged is:',
  youSelectPay: 'You have chosen to pay by ',
  youWillBeForwardedTo: '. You will be forwarded to the ',
  websiteToProceedWithThisTransaction: ' website to proceed with this transaction.',
  payMethod: 'Payment method',
  qrCodePresale: 'Pre-sales service',
  qrCodePostsale: 'After sales service',
  completeWeatchPay: 'Complete Your Booking with WeChat Pay',
  useWechatToQecodePay: 'Use WeChat to scan the QR code. Complete your payment on WeChat.',
  step1: 'Step 1',
  step2: 'Step 2',
  accordingToPaymentResultSelect: 'According to the payment result on WeChat, click &apos;Payment Successful&apos; below if payment was successful or &apos;Payment Had Problems&apos; if payment was unsuccessful.',
  paymentHadProblems: 'Payment Had Problems',
  paymentSpuccessful: 'Payment Successful',
  hotelAndYouWillReceiveFinalBookingStatusInboxLeft: 'So we will double check the inventory with the hotel and keep you informed of the updated booking status within',
  hotelAndYouWillReceiveFinalBookingStatusInboxRight: 'minutes.',
  bookingIsPendingWekeepYouInformedMinutesLeft: 'Your booking is pending. We will keep you informed of the updated booking status within',
  bookingIsPendingWekeepYouInformedMinutesRight: 'minutes.',
  payDisabled: 'Payment page has expired',
  payContact: 'Please contact our customer service for assistance. The contact information for customer service is as follows:',
  emailNotVerify: 'Your email is not verified, please go to your email to verify it.',
  youBeenThisPageForeTooLongTimeToRefresh: 'The page has been idle for too long, please refresh.',
  paymentFailurePrompt: 'Your booking failed because your payment was declined. Please verify your account information or try using a different account to complete the payment. If you continue to experience issues, please contact our customer service for assistance. Our customer service contact information is as follows:',
  breakfastnum: 'for',
  childPayTop: 'There is an unpaid amount in your order. Please complete the payment within 1 day to avoid the failure of modification.',
  childPayTip: 'Modify order, pending payment amount!',
  childPayTopMobile: 'Please complete the payment within 1 day to avoid the failure of modification.',
  childPayOverTimeTip: 'Modify order, payment pending timeout!',
  bindEmail: 'Bind Email',
  buttonBindNow: 'Bind Now',
  unbindEmailMessage: 'WeChat authorization successful, please bind your Email',
  registerAndBindEmail: 'Register and bind email',
  emailAlreadyBind: 'Unable to bind, this email has already been bound to another WeChat account. Please use a new email address to proceed with the binding process.',
  wechatAlreadyBind: 'This WeChat account has been bound to an email, please log in directly',
  otherAuthorization: 'Other login methods',
  InvalidAuthorization: 'Invalid WeChat authorization information',
  additionalCharge: 'Itinerary price difference',
  changeBindEmail: 'Change binding email',
  wechatAccount: 'WeChat account',
  wechatBindTime: 'Binding time',
  unBindWechat: 'Unbind wechat',
  bindWechat: 'Bind wechat',
  mandaFee: 'mandatory fee',
  currentLanguage: 'en',
  confirmTitle: 'Confirm operation',
  unBindWechatConfirmMessage: 'Are you sure you want to unbind your WeChat account?',
  unBindWechatSuccess: 'Unbind successfully',
  userinfoNotFind: 'No user information found. Please refresh and try again!',
  wechatNotBind: 'This account is not bound to WeChat authorization',
  uniqueLoginMethod: 'This account can only be logged in through this method and cannot be unbound',
  wechatLoginSuccess: 'WeChat has logged in',
  pageJumpPrompt: 'page is redirecting',
  bindEmailPrompt: 'If you already have another email account, you can click on Bind Email to merge your accounts. If not, you can click on Direct Login.',
  directLogin: 'direct Login',
  bindEmailSuccess: 'binding successful.',
  emailNotRegistered: 'No account has been created with this email address. If you wish to create an account and bind it, please proceed to My Account to complete the process.',
  loginSuccess: 'Login successful',
  unbindWechatTitle: 'Unbind WeChat account',
  unbindWechatDesc: 'Are you sure you want to unbind your WeChat account?',
  userId: 'User ID',
  bindWechatSuccess: 'WeChat binding successful',
  buttonCancel: 'cancel',
  buttonSave: 'save',
  buttonBindEmail: 'Bind Email',
  buttonCheckEmail: 'Check Email',
  buttonUnBindEmail: 'Unbind Email',
  lastNameError: 'Please enter a valid last name.',
  firstNameError: 'Please enter a valid name.',
  emailError: 'Please enter a valid email address.',
  passWordError: 'Password must be at least 6 characters',
  passWordTwoError: 'The passwords entered twice do not match.',
  mobileEmailCheckNotice: 'Verification email has been sent to your bound email address. Please check and complete the verification.',
  unbindEmailSuccessNotice: 'Unbinding successful.',
  mobileBindEmailSuccessNotice: 'Binding successful, but your email has not been verified. We have sent a verification email to your bound email. Please check and complete the verification.',
  bindEmailIsset: 'This email has been linked to another account. Please try using a different email account.',
  mobileCheckEmailVerifySuccess: 'Email has been verified.',
  iconBound: 'Bound',
  iconNotVerified: 'Not verified',
  iconVerified: 'Verified',
  iconNotBound: 'Not bound',
  modifySuccess: 'Modification successful',
  modifyFail: 'Modification failed',
  unBindEmailConfirmMessage: 'Are you sure you want to unlink your email account?',
  edit: 'Edit',
  commission: 'commission',
  roompaiCommissionNotification: 'The term “commission” mentioned here specifically refers to the fees charged by Roompai for providing booking services to you. We charge a certain fee for each order placed.',
  taxesFeesGoogle: 'The term “taxes” referred to here specifically refers to the taxes paid by Roompai on behalf of the suppliers (such as hotels). For detailed information, please refer to our terms of use.',
  taxesAndCharges: 'taxes and charges',
  notIncludedInTotal: 'Not included in your total',
  mandatoryChargeHotelCollected: 'Mandatory charge: collected at property.',
  details: 'Details',
  goPay: 'Pay now',
  取消成功: '',
  cancelSuccess: 'Cancel Success',
  cancelSuccessNotice: 'If the order used a coupon, the coupon has been refunded to your account and can be used for your next booking~',
  waitPay: 'Unpaid',
  wechatNotice_website_mobile: 'Due to WeChat&apos;s restrictions, payment orders cannot be completed on the mobile end for web-based transactions. Please return to the web page to continue the payment. Thank you!',
  wechatNotice_mobile_website: 'Due to WeChat restrictions, payment for mobile orders cannot be completed on the web page. Please return to the mobile device to continue the payment. Thank you!',
  matchHotelMsg: 'This charming hotel awaits you.',
  cityTaxFee: 'City Tax',
  destinationFee: 'Destination fee',
  serviceFee: 'Service fee',
  cleaningFee: 'Cleaning fee',
  couponUselargeMsg: 'Your coupon has been successfully applied. This booking has saved you',
  point: '.',
  couponUseshortMsg: 'Coupon used',
  authorizedLoginTitle: 'or continue with',
  Google: 'Google',
  Facebook: 'Facebook',
  Apple: 'Apple',
  remove: 'remove',
  mobile: 'Mobile',
  getMobileCode: 'Get code',
  mobileTitle: 'Mobile',
  inputMobileCode: 'Please input verification code',
  pleaseValidMobileCode: 'Please enter the correct 6-digit verification code',
  codeExpire: 'Verification code has expired',
  timeLimit: 'We have run out of times today, please come back tomorrow!',
  CodeError: 'Verification code error',
  systemError: 'System error, please try again later',
  sendCodeSuccess: 'Verification code sent successfully',
  countLimit: 'We have run out of times today, please come back tomorrow!',
  invalidMobileArea: 'Temporarily Unsupported Regions',
  authorizedRegisterTitle: 'or continue with',
  authorizedForgetTitle: 'Recommended Login Method',
  noLoginNoticeText: 'Login for lower prices!',
  mailboxExistsNew: 'An account already exists for this email address. ',
  oldmobile: 'Old mobile',
  newmobile: 'New mobile',
  buttonBindMobile: 'Bind mobile',
  buttonUpdateMobile: 'Update mobile',
  administrativeFee: 'Administrative fee',
  mobileExists: 'mobile exists',
  coupon: 'Coupon',
  noCoupon: 'No coupons are currently available',
  bindMobileSuccess: 'Bind mobile success',
  oldMobileNotMatch: 'Old mobile not match',
  mobileNumbersCannotBeTheSame: 'mobile cannot be the same',
  invalidMobile: 'Invalid mobile number',
  emailLogin: 'EMAIL',
  mobileLogin: 'MOBILE',
  validDate: 'Validity period:',
  useNow: 'Use now',
  used: 'Used',
  expired: 'Expired',
  unUsed: 'Unused',
  codeValid: 'Your code is still valid, no need to request a new one.',
  noDestination: 'I\'m sorry, we don\'t have this destination yet.',
  interceptingTextTwoCustomerServiceTeam: 'customer service team.',
  interceptingTextOne: 'Sorry, we\'ve detected some unusual activity associated with your account. To ensure your security, we\'ve temporarily restricted your access.',
  interceptingTextTwo: 'If you have any questions, please',
  interceptingTextThree: 'Thank you for your understanding and cooperation.',
  interceptingTextTwoContactOur: 'contact our',
  BookingId: 'Booking ID',
  hotelName: 'Hotel Name',
  checkInDate: 'Check-in Date',
  checkOutDate: 'Check-out Date',
  totalPaymentAmount: 'Total Payment Amount',
  ConfirmIng: 'confirming',
  paymentConfirmSuccess: 'Payment confirmation successful',
  paymentConfirmFail: 'Payment confirmation failed',
  paymentConfirmFailNotice: 'Your card or account will receive the refund amount within 10 business days. If you have any further questions regarding the refund, please contact your bank/credit card issuing institution directly.and if you have other questions, feel free to',
  paymentConfirmSuccessNotice: 'You have successfully completed the payment confirmation! We will promptly verify your order with the hotel. The final result will be sent to the email you provided when placing the order(',
  paymentConfirmSuccessNoticeTwo: '). If you have any questions, please feel free to',
  AccountSecurityWarning: 'Account Security Warning',
  bookingPendingPaymentSecondConfirm: 'To ensure the security of your transaction, please proceed to your payment email (',
  bookingPendingPaymentSecondConfirmTwo: ') to complete the payment confirmation. If confirmation is not completed within 2 hours, the order may be canceled.',
  RecommendedByNearbyHotels: 'Recommended by nearby hotels',
  TransactionFee: 'Transaction fee',
  TransactionFeeMsgFirst: '(Includes a',
  TransactionFeeMsgLast: 'transaction fee)',
  paymentFailPopUp: 'Payment failed',
  paymentFailDesc: 'Please verify your bank card information and ensure sufficient funds are available. Alternatively, use another payment method.',
  retry: 'Retry',
  pleaseTickTheCheckbox: 'Please tick the checkbox above to indicate that you have read and agreed to our Terms of use and Privacy policy',
  agreeToRoompai: 'I agree to Roompai\'s',
  noAccountMsg: 'Please register an account before logging in.',
  noneRoomSamePriceMsgLeft: 'The selected room is sold out. The',
  noneRoomSamePriceMsgRight: 'is now available at the same price. Would you like to continue?',
  noneRoomNonePriceMsgRight: 'more. Would you like to continue?',
  noneRoomNonePriceMsgCenter: 'is now available for',
  secSpecialRequestsAreGuaranteed: 'According to hotel requirements, you need to provide your arrival flight number and departure flight number to proceed with the booking.',
  secSpecialRequestsAreGuaranteedAlert: 'Please enter your arrival and departure flight numbers.'
}
export default en



// WEBPACK FOOTER //
// ./src/util/en.js